import { useParams } from "react-router-dom";
import { MuiPage } from "../../../components";
import { MuiAccordionArray } from "../../../components/MuiAccordionArray";
import MenuEdit from "./menu.edit";
import { MenuFeaturesMapping } from "./menuAccordian/menu.feature";
import { MenuRoleMapping } from "./menuAccordian/menu.role";
import { getLocalStorageItem } from "../../../utils/storageHelper";

export const MenuAddEdit = (props: any) => {
    const { id: MenuId } = useParams()
    const ApplicationId = getLocalStorageItem('ApplicationId')

    const accordionArray = [
        {
            panelId: 'Panel1',
            name: ("Role"),
            child: <MenuRoleMapping request={{ MenuId, ApplicationId }} />
        },
        {
            panelId: 'Panel2',
            name: ("Feature"),
            child: <MenuFeaturesMapping request={{ MenuId, ApplicationId }} />
        },
    ]

    return (
        <MuiPage>
            <MenuEdit />
            {!!MenuId && (
                <MuiAccordionArray
                    accordionArray={accordionArray}
                />
            )}
        </MuiPage>
    );
}